<template>
  <ol>
    <slot />
  </ol>
</template>
